import {CustomField, CustomFieldEntityTypesEnum} from '@shipwell/backend-core-singlerequestparam-sdk';

export const isSingleSelectionList = (fieldType?: string) => fieldType === 'SELECTION';
export const getPOCustomFieldsByType = (customFields: CustomField[], entityType: CustomFieldEntityTypesEnum) =>
  customFields.filter((cf) => cf.entity_types?.includes(entityType));
